var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingBagIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Shopping_Bag_Line",
    "data-name": "icons/Shopping Bag/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.99,
    height: 13.333,
    viewBox: "0 0 12.99 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M10.323,1.333H2.667A1.333,1.333,0,0,0,1.336,2.75l.333,5.333A1.333,1.333,0,0,0,3,9.333H9.99a1.333,1.333,0,0,0,1.331-1.25l.333-5.333A1.333,1.333,0,0,0,10.323,1.333ZM2.667,0A2.667,2.667,0,0,0,.005,2.833L.339,8.166A2.667,2.667,0,0,0,3,10.667H9.99a2.667,2.667,0,0,0,2.661-2.5l.333-5.333A2.667,2.667,0,0,0,10.323,0Z",
    transform: "translate(0 2.667)",
    fill: "#fcfcfd",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M0,3.333a3.333,3.333,0,0,1,6.667,0V4.667a.667.667,0,0,1-1.333,0V3.333a2,2,0,1,0-4,0V4.667A.667.667,0,0,1,0,4.667Z",
    transform: "translate(3.162)",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBagIcon);
export default __webpack_public_path__ + "static/media/shoppingBagIcon.19b42a8deea18867d87ee6f837ff3c74.svg";
export { ForwardRef as ReactComponent };